import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
Vue.config.productionTip = false

import App from '@/App.vue'
import Home from '@/Home.vue'
import PortfolioSingle from '@/components/Portfolio/Single.vue'

const routes = [
  {
    name: 'Home',
    path: '/',
    component: Home,
  },
  {
    name: "Portfolio Single",
    path: '/portfolio/:slug',
    component: PortfolioSingle,
    props: true,
  },
  {
    name: 'Error',
    path: '/*',
    component: Home,
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
